import { Component } from '@angular/core';

@Component({
  selector: 'app-background-icon-collection',
  templateUrl: './background-icon-collection.component.html',
  styleUrl: './background-icon-collection.component.scss',
})
export class BackgroundIconCollectionComponent {}